import { HANDLE_REDIRECT } from '../actionConstants/commonConstants';

// eslint-disable-next-line
export const handleRedirect = ({ url, isInner }) => ({ type: HANDLE_REDIRECT, payload: { url, isInner } });
